module.exports = __webpack_public_path__ + "img/favour.ec0f6950.gif";